export default __webpack_public_path__ + "static/media/announcement-highlight-by-type-outer.62cafc1a.svg";